import React from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, IconButton } from '@c2fo/liquidity';
import { EllipsisVerticalIcon } from '@c2fo/liquidity/icons';

interface ActionsMenuProps {
  children: React.ReactNode;
}

export const ActionsMenu: React.FC<ActionsMenuProps> = ({ children }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton icon={EllipsisVerticalIcon} name="Actions" variant="ancillary" size="sm" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">{children}</DropdownMenuContent>
    </DropdownMenu>
  );
};
